import useMountedRef from '@aytm/lib/hooks/useMountedRef'
import { useEffect, useRef, useState } from 'react'

import DevLog from '../devlog/Module'
import ImagesModule from './Module'

import { IQuestionModel } from '../../questions/types'

export default function usePreloadImages(model: IQuestionModel): boolean {
  const preloadImagesRef = useRef<[IQuestionModel, string[]]>(null)
  if (null === preloadImagesRef.current) {
    preloadImagesRef.current = [model, model.preloadImages]
  }

  const [preloaded, setPreloaded] = useState<boolean>(0 === preloadImagesRef.current?.[1]?.length)
  const mountedRef = useMountedRef()
  const preloadingRef = useRef(false)

  useEffect(() => {
    if (preloadingRef.current) return
    preloadingRef.current = true

    if (model !== preloadImagesRef.current?.[0]) {
      preloadImagesRef.current = [model, model.preloadImages]
    }
    if (preloadImagesRef.current[1].length) {
      setPreloaded(false)
      Promise.all(
        preloadImagesRef.current[1].map(imageAsset => {
          if (!imageAsset) return Promise.resolve('')
          if (imageAsset) {
            const img = new Image()
            img.onload = () => Promise.resolve({ imageAsset })

            img.onerror = () => Promise.resolve({ imageAsset })
            img.src = imageAsset
          }
          return Promise.resolve(imageAsset)
        })
      )
        .then(() => {
          if (mountedRef.current) {
            setPreloaded(true)
          }
        })
        .catch(error => {
          DevLog.moduleError(ImagesModule, error, 'usePreloadImages')
          setPreloaded(true)
        })
    } else {
      setPreloaded(true)
    }
  }, [model, mountedRef])

  return preloaded
}
